import { AppBar, Toolbar, MenuItem, ListItemIcon, Stack, useMediaQuery, ButtonBase, Avatar, Typography, Divider, IconButton, Tooltip } from '@mui/material'
import { Box } from '@mui/system';
import React, { useEffect } from 'react';
import logo from "../../assets/svg/logo.svg";
import { AccountCircle, Edit, Logout } from '@mui/icons-material';
import DDMenu from '../DDMenu';
import { useNavigate } from 'react-router-dom';
import route from '../../utils/Routes';
import { formatName, getFirstLetter, isEmpty, isNotEmpty, makeTxtOverFLow } from '../../utils/format';
import { useState } from 'react';
import { useQuery } from 'react-query';
import QueryKey from '../../utils/QueryKey';
import { useAuthContext } from '../../context/AuthContext';
import { getComUserProfile, getUserProfile } from '../../services/com-service';
import constants from '../../utils/Constants';
import { getFileUrl } from '../../services/s3-service';
import { customAlert, notify } from '../notify';
import AddPotProjDet from './AddPotProjDet';
import shellLogo from '../../assets/png/shell_logo.png'

function NavBar() {
    const [anchorEl, setAnchorEl] = useState(null);
    const { setLoadingScreen, ctxtUser, setAsyncLoading, ctxtlogout, selCom } = useAuthContext();
    const open = Boolean(anchorEl);
    const isLarge = useMediaQuery("(min-width: 600px)");
    const navigate = useNavigate();
    const { data: comData, isLoading } = useQuery([QueryKey.comUserProfile, ctxtUser?.userId],
        () => getUserProfile({ userId: ctxtUser?.userId, isComUser: ctxtUser?.isComUser }),
        {
            enabled: isNotEmpty(ctxtUser?.userId),
            cacheTime: 0, // Immediately clear the cache
            staleTime: Infinity, // Prevent automatic background refetching
        });
    const fontColor = "rgba(0, 0, 0, 0.8)";
    const reqMenuList = [
        {
            title: "Logout",
            icon: <Logout fontSize="small" />,
            fn: handleLogout
        }
    ];
    const [mdl, selMdl] = useState(false);
    const handleMdlClose = () => selMdl(false);
    const handleMdlOpen = () => selMdl(true);

    useEffect(() => {
        if (isLoading) {
            setLoadingScreen(true);
        } else {
            setLoadingScreen(false);
        }
    }, [isLoading, setLoadingScreen]);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    function handleLogout() {
        setAsyncLoading(true);
        ctxtlogout();
        setAsyncLoading(false);
        notify("info", "Logout successfully");
    }



    return (
        <Box flexGrow={1}>
            <AppBar position='static' color='primary' elevation={0} sx={{ borderBottom: 1, borderColor: "#E3E3E3" }}>
                <Toolbar variant="dense">
                    <Box flexGrow={1} display={"flex"} flexDirection={"row"} alignItems={"center"}>
                        <ButtonBase component={"div"} onClick={() => navigate("/", { replace: true })}>
                            {/* <Box component="img" alt="Comoany Logo" src={logo} sx={{ height: 45 }} onClick={() => navigate("/")} /> */}
                            <Box component="img" alt="Comoany Logo" src={logo} sx={{ height: 45 }} />
                        </ButtonBase>
                        <Box sx={{ fontSize: 13, px: 1, fontWeight: "500", color: fontColor }}>AL MUHARA AL ASEELA TRADING AND CONTRACTING (AMTC)</Box>
                    </Box>
                    <Stack direction={"row"}  >
                        {(isEmpty(selCom?.comId) === false && <Stack direction={"row"} alignItems={"center"} >
                            <Stack direction={"row"} alignItems={"center"} >
                                {selCom?.comLogo === "shell" ? <Avatar alt='comLogo' src={shellLogo} sx={{ height: 25, width: 25, fontSize: 15 }} /> :
                                    <Avatar alt='comLogo' sx={{ height: 25, width: 25, fontSize: 15 }}  >{getFirstLetter(selCom?.comName)}</Avatar>}


                                {selCom?.comName && <Tooltip title={selCom?.comName}>
                                    <Box sx={{ fontSize: 15, px: 1, fontWeight: "500", color: fontColor }}>  {makeTxtOverFLow(selCom?.comName, 24)}</Box>
                                </Tooltip>}
                            </Stack>
                            <Stack direction={"row"} alignItems={"center"} sx={{
                                border: 0.5, width: 350, height: 30, fontSize: 14, mx: 3,
                                fontWeight: "500", borderRadius: 1, borderColor: "white"
                            }}>
                                <Box px={1}>
                                    PROJECT
                                </Box>
                                <Divider orientation='vertical' sx={{ borderColor: "white", borderWidth: 1 }} />

                                <Box width={"50%"} pl={1} flexGrow={1}>
                                    {selCom?.potProjDet && <Tooltip title={selCom?.potProjDet}>
                                        <Box>
                                            {makeTxtOverFLow(selCom?.potProjDet, 22)}
                                        </Box>
                                    </Tooltip>}
                                </Box>

                                {ctxtUser?.userType === constants.admin && <Box bgcolor={"white"} height={"100%"} display={"flex"} alignItems={"center"} >
                                    <IconButton onClick={handleMdlOpen}>
                                        <Edit sx={{ fontSize: 20, color: "primary" }} />
                                    </IconButton>
                                </Box>}
                            </Stack>
                        </Stack>)}
                        <ButtonBase component="div" onClick={(handleClick)} sx={{ color: fontColor }}>
                            <Stack direction={"row"} alignItems={"center"} >
                                <Avatar alt='profile_image' sx={{ height: 25, width: 25, fontSize: 15 }} >
                                    {getFirstLetter(comData?.fName)}</Avatar>
                                <Box sx={{ fontSize: 15, px: 1, fontWeight: "500" }}>  {makeTxtOverFLow(formatName(comData?.fName, comData?.lName), 24)}</Box>
                            </Stack>
                        </ButtonBase>
                        <DDMenu open={open} handleClose={handleClose} anchorEl={anchorEl} >
                            {reqMenuList.map(
                                (i) => <MenuItem onClick={() => { i.fn(); }} key={i.title}>
                                    <ListItemIcon > {i.icon}</ListItemIcon>
                                    {i.title}
                                </MenuItem>)}
                        </DDMenu>
                    </Stack>

                </Toolbar>
            </AppBar>
            {isNotEmpty(selCom?.comId) && <AddPotProjDet modalOpen={mdl} handleModalClose={handleMdlClose} selComData={selCom} />}
        </Box>
    )
}

export default NavBar;